import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ManageOpenShiftsService } from 'app/modules/manage-shifts/services/manage-open-shifts.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { WeekMonthDatePipe } from 'app/modules/shared/pipes/week-month-date.pipe';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment-timezone';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-manage-shifts-team-members-day-list',
  templateUrl: './manage-shifts-team-members-day-list.component.html',
  styleUrls: ['./manage-shifts-team-members-day-list.component.scss']
})
export class ManageShiftsTeamMembersDayListComponent implements OnInit {
  @Input() searchTeam: any;
  @Input() fromDate: any;
  @Input() selectedAvailability: any;
  @Input() selectedRole: any;
  @Input() userRoleIds: any;
  @Input() offset: any;
  @Input() isPastDate: any;
  @Input() providerId: any;
  @Input() serviceRegionIds: any;
  @Output() totalCount: EventEmitter<any> = new EventEmitter<any>();
  toDate = new Date();
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  teamMemberDetails: any[] = [];
  editSlotDetails: any;
  addTimeOffDetails: any;
  limit = 10;
  currentOffset = 10;
  selectedTeam: any;
  selectedDate: any;
  driverId: any;
  shiftDetails: any;
  showAddTimeOffPopup = false;
  showEditPopup = false;
  sortType = 'asc';
  providerFinalResponse = [];
  timeslots = [
    { lable: '12:00 AM', value: '12:00 AM' },
    { lable: '01:00 AM', value: '01:00 AM' },
    { lable: '02:00 AM', value: '02:00 AM' },
    { lable: '03:00 AM', value: '03:00 AM' },
    { lable: '04:00 AM', value: '04:00 AM' },
    { lable: '05:00 AM', value: '05:00 AM' },
    { lable: '06:00 AM', value: '06:00 AM' },
    { lable: '07:00 AM', value: '07:00 AM' },
    { lable: '08:00 AM', value: '08:00 AM' },
    { lable: '09:00 AM', value: '09:00 AM' },
    { lable: '10:00 AM', value: '10:00 AM' },
    { lable: '11:00 AM', value: '11:00 AM' },
    { lable: '12:00 PM', value: '11:00 PM' },
    { lable: '01:00 PM', value: '01:00 PM' },
    { lable: '02:00 PM', value: '02:00 PM' },
    { lable: '03:00 PM', value: '03:00 PM' },
    { lable: '04:00 PM', value: '04:00 PM' },
    { lable: '05:00 PM', value: '05:00 PM' },
    { lable: '06:00 PM', value: '06:00 PM' },
    { lable: '07:00 PM', value: '07:00 PM' },
    { lable: '08:00 PM', value: '08:00 PM' },
    { lable: '09:00 PM', value: '09:00 PM' },
    { lable: '10:00 PM', value: '10:00 PM' },
    { lable: '11:00 PM', value: '11:00 PM' },
  ];
  timeslots15m = [
    { start: '12:00 AM', end: '12:15 AM', eStart: '0', eEnd: '900000' },
    { start: '12:15 AM', end: '12:30 AM', eStart: '900000', eEnd: '1800000' },
    { start: '12:30 AM', end: '12:45 AM', eStart: '1800000', eEnd: '2700000' },
    { start: '12:45 AM', end: '01:00 AM', eStart: '2700000', eEnd: '3600000' },
    { start: '01:00 AM', end: '01:15 AM', eStart: '3600000', eEnd: '4500000' },
    { start: '01:15 AM', end: '01:30 AM', eStart: '4500000', eEnd: '5400000' },
    { start: '01:30 AM', end: '01:45 AM', eStart: '5400000', eEnd: '6300000' },
    { start: '01:45 AM', end: '02:00 AM', eStart: '6300000', eEnd: '7200000' },
    { start: '02:00 AM', end: '02:15 AM', eStart: '7200000', eEnd: '8100000' },
    { start: '02:15 AM', end: '02:30 AM', eStart: '8100000', eEnd: '9000000' },
    { start: '02:30 AM', end: '02:45 AM', eStart: '9000000', eEnd: '9900000' },
    { start: '02:45 AM', end: '03:00 AM', eStart: '9900000', eEnd: '10800000' },
    { start: '03:00 AM', end: '03:15 AM', eStart: '10800000', eEnd: '11700000' },
    { start: '03:15 AM', end: '03:30 AM', eStart: '11700000', eEnd: '12600000' },
    { start: '03:30 AM', end: '03:45 AM', eStart: '12600000', eEnd: '13500000' },
    { start: '03:45 AM', end: '04:00 AM', eStart: '13500000', eEnd: '14400000' },
    { start: '04:00 AM', end: '04:15 AM', eStart: '14400000', eEnd: '15300000' },
    { start: '04:15 AM', end: '04:30 AM', eStart: '15300000', eEnd: '16200000' },
    { start: '04:30 AM', end: '04:45 AM', eStart: '16200000', eEnd: '17100000' },
    { start: '04:45 AM', end: '05:00 AM', eStart: '17100000', eEnd: '18000000' },
    { start: '05:00 AM', end: '05:15 AM', eStart: '18000000', eEnd: '18900000' },
    { start: '05:15 AM', end: '05:30 AM', eStart: '18900000', eEnd: '19800000' },
    { start: '05:30 AM', end: '05:45 AM', eStart: '19800000', eEnd: '20700000' },
    { start: '05:45 AM', end: '06:00 AM', eStart: '20700000', eEnd: '21600000' },
    { start: '06:00 AM', end: '06:15 AM', eStart: '21600000', eEnd: '22500000' },
    { start: '06:15 AM', end: '06:30 AM', eStart: '22500000', eEnd: '23400000' },
    { start: '06:30 AM', end: '06:45 AM', eStart: '23400000', eEnd: '24300000' },
    { start: '06:45 AM', end: '07:00 AM', eStart: '24300000', eEnd: '25200000' },
    { start: '07:00 AM', end: '07:15 AM', eStart: '25200000', eEnd: '26100000' },
    { start: '07:15 AM', end: '07:30 AM', eStart: '26100000', eEnd: '27000000' },
    { start: '07:30 AM', end: '07:45 AM', eStart: '27000000', eEnd: '27900000' },
    { start: '07:45 AM', end: '08:00 AM', eStart: '27900000', eEnd: '28800000' },
    { start: '08:00 AM', end: '08:15 AM', eStart: '28800000', eEnd: '29700000' },
    { start: '08:15 AM', end: '08:30 AM', eStart: '29700000', eEnd: '30600000' },
    { start: '08:30 AM', end: '08:45 AM', eStart: '30600000', eEnd: '31500000' },
    { start: '08:45 AM', end: '09:00 AM', eStart: '31500000', eEnd: '32400000' },
    { start: '09:00 AM', end: '09:15 AM', eStart: '32400000', eEnd: '33300000' },
    { start: '09:15 AM', end: '09:30 AM', eStart: '33300000', eEnd: '34200000' },
    { start: '09:30 AM', end: '09:45 AM', eStart: '34200000', eEnd: '35100000' },
    { start: '09:45 AM', end: '10:00 AM', eStart: '35100000', eEnd: '36000000' },
    { start: '10:00 AM', end: '10:15 AM', eStart: '36000000', eEnd: '36900000' },
    { start: '10:15 AM', end: '10:30 AM', eStart: '36900000', eEnd: '37800000' },
    { start: '10:30 AM', end: '10:45 AM', eStart: '37800000', eEnd: '38700000' },
    { start: '10:45 AM', end: '11:00 AM', eStart: '38700000', eEnd: '39600000' },
    { start: '11:00 AM', end: '11:15 AM', eStart: '39600000', eEnd: '40500000' },
    { start: '11:15 AM', end: '11:30 AM', eStart: '40500000', eEnd: '41400000' },
    { start: '11:30 AM', end: '11:45 AM', eStart: '41400000', eEnd: '42300000' },
    { start: '11:45 AM', end: '12:00 PM', eStart: '42300000', eEnd: '43200000' },
    { start: '12:00 PM', end: '12:15 PM', eStart: '43200000', eEnd: '44100000' },
    { start: '12:15 PM', end: '12:30 PM', eStart: '44100000', eEnd: '45000000' },
    { start: '12:30 PM', end: '12:45 PM', eStart: '45000000', eEnd: '45900000' },
    { start: '12:45 PM', end: '01:00 PM', eStart: '45900000', eEnd: '46800000' },
    { start: '01:00 PM', end: '01:15 PM', eStart: '46800000', eEnd: '47700000' },
    { start: '01:15 PM', end: '01:30 PM', eStart: '47700000', eEnd: '48600000' },
    { start: '01:30 PM', end: '01:45 PM', eStart: '48600000', eEnd: '49500000' },
    { start: '01:45 PM', end: '02:00 PM', eStart: '49500000', eEnd: '50400000' },
    { start: '02:00 PM', end: '02:15 PM', eStart: '50400000', eEnd: '51300000' },
    { start: '02:15 PM', end: '02:30 PM', eStart: '51300000', eEnd: '52200000' },
    { start: '02:30 PM', end: '02:45 PM', eStart: '52200000', eEnd: '53100000' },
    { start: '02:45 PM', end: '03:00 PM', eStart: '53100000', eEnd: '54000000' },
    { start: '03:00 PM', end: '03:15 PM', eStart: '54000000', eEnd: '54900000' },
    { start: '03:15 PM', end: '03:30 PM', eStart: '54900000', eEnd: '55800000' },
    { start: '03:30 PM', end: '03:45 PM', eStart: '55800000', eEnd: '56700000' },
    { start: '03:45 PM', end: '04:00 PM', eStart: '56700000', eEnd: '57600000' },
    { start: '04:00 PM', end: '04:15 PM', eStart: '57600000', eEnd: '58500000' },
    { start: '04:15 PM', end: '04:30 PM', eStart: '58500000', eEnd: '59400000' },
    { start: '04:30 PM', end: '04:45 PM', eStart: '59400000', eEnd: '60300000' },
    { start: '04:45 PM', end: '05:00 PM', eStart: '60300000', eEnd: '61200000' },
    { start: '05:00 PM', end: '05:15 PM', eStart: '61200000', eEnd: '62100000' },
    { start: '05:15 PM', end: '05:30 PM', eStart: '62100000', eEnd: '63000000' },
    { start: '05:30 PM', end: '05:45 PM', eStart: '63000000', eEnd: '63900000' },
    { start: '05:45 PM', end: '06:00 PM', eStart: '63900000', eEnd: '64800000' },
    { start: '06:00 PM', end: '06:15 PM', eStart: '64800000', eEnd: '65700000' },
    { start: '06:15 PM', end: '06:30 PM', eStart: '65700000', eEnd: '66600000' },
    { start: '06:30 PM', end: '06:45 PM', eStart: '66600000', eEnd: '67500000' },
    { start: '06:45 PM', end: '07:00 PM', eStart: '67500000', eEnd: '68400000' },
    { start: '07:00 PM', end: '07:15 PM', eStart: '68400000', eEnd: '69300000' },
    { start: '07:15 PM', end: '07:30 PM', eStart: '69300000', eEnd: '70200000' },
    { start: '07:30 PM', end: '07:45 PM', eStart: '70200000', eEnd: '71100000' },
    { start: '07:45 PM', end: '08:00 PM', eStart: '71100000', eEnd: '72000000' },
    { start: '08:00 PM', end: '08:15 PM', eStart: '72000000', eEnd: '72900000' },
    { start: '08:15 PM', end: '08:30 PM', eStart: '72900000', eEnd: '73800000' },
    { start: '08:30 PM', end: '08:45 PM', eStart: '73800000', eEnd: '74700000' },
    { start: '08:45 PM', end: '09:00 PM', eStart: '74700000', eEnd: '75600000' },
    { start: '09:00 PM', end: '09:15 PM', eStart: '75600000', eEnd: '76500000' },
    { start: '09:15 PM', end: '09:30 PM', eStart: '76500000', eEnd: '77400000' },
    { start: '09:30 PM', end: '09:45 PM', eStart: '77400000', eEnd: '78300000' },
    { start: '09:45 PM', end: '10:00 PM', eStart: '78300000', eEnd: '79200000' },
    { start: '10:00 PM', end: '10:15 PM', eStart: '79200000', eEnd: '80100000' },
    { start: '10:15 PM', end: '10:30 PM', eStart: '80100000', eEnd: '81000000' },
    { start: '10:30 PM', end: '10:45 PM', eStart: '81000000', eEnd: '81900000' },
    { start: '10:45 PM', end: '11:00 PM', eStart: '81900000', eEnd: '82800000' },
    { start: '11:00 PM', end: '11:15 PM', eStart: '82800000', eEnd: '83700000' },
    { start: '11:15 PM', end: '11:30 PM', eStart: '83700000', eEnd: '84600000' },
    { start: '11:30 PM', end: '11:45 PM', eStart: '84600000', eEnd: '85500000' },
    { start: '11:45 PM', end: '12:00 AM', eStart: '85500000', eEnd: '86400000' },

  ];
  showRole: Boolean = false;
  isPTOEnable: Boolean = false;
  isOrgLevelDOO: Boolean = false;
  organizationLevelDispatch: Boolean = false;
  providerArr: any = [];
  teamDutyOOArr: any = [];

  constructor(
    private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService,
    private confirmationService: ConfirmationService,
    private commonService: CommonBindingDataService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.showRoleName();
    this.isPTOEnable = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value;
    this.isOrgLevelDOO = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.ORGANIZATION_LVL)?.value;
    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.forEach(ele => {
      this.providerArr.push(ele.providerId);
    });
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.forEach(ele => {
      this.teamDutyOOArr.push(ele.teamId);
    });
    console.warn(this.teamDutyOOArr);
  }

  showRoleName() {
    if (this.selectedRole === '20') {
      this.showRole = true;
    } else {
      this.showRole = false;
    }
  }

  ngOnChanges() {
    this.toDate.setTime(this.fromDate.getTime());
    this.getTeamMemberList();
    this.showRoleName();
  }

  getTeamMemberList() {
    // this.isLoaded = false;
    const formattedFromDate = moment(this.fromDate).format('YYYY/MM/DD');
    const formattedToDate = moment(this.toDate).format('YYYY/MM/DD');
    const formattedStatusId = this.selectedAvailability.length ? this.selectedAvailability : '';
    this.manageOpenShiftsService.getTeamMemberList(formattedFromDate, formattedToDate, this.limit,
      this.offset, this.searchTeam, formattedStatusId, this.selectedRole, this.userRoleIds, this.sortType, 'day',
      this.providerId, this.serviceRegionIds)
      .subscribe((teamMemberDetails) => {
        // this.isLoaded = true;
        this.totalCount.emit(teamMemberDetails.count);
        if (this.offset > this.currentOffset) {
          this.currentOffset = this.offset;
          const data = teamMemberDetails.data;
          this.teamMemberDetails = [...this.teamMemberDetails, ...data];
        } else {
          this.teamMemberDetails = teamMemberDetails.data;
          this.currentOffset = this.offset;
        }


        this.providerFinalResponse = [];
        this.teamMemberDetails.forEach(element => {
          console.log('element', element);
          const timeSlot15 = this.timeslots15m;
          for (let i = 0; i < this.timeslots15m.length; i++) {
            timeSlot15[i]['available'] = '';
            for (let j = 0; j < element.memberSchedules[0].userTeams.length; j++) {
              if (!timeSlot15[i]['available']) {
                // if((element.memberSchedules[j]?.availableFrom  <= this.timeslots15m[i].eStart ) &&
                // ( element.memberSchedules[j]?.availableTo >  this.timeslots15m[i].eEnd)){
                if ((this.timeslots15m[i].eStart >= element.memberSchedules[0].userTeams[j].availableFrom) &&
                (this.timeslots15m[i].eEnd <= element.memberSchedules[0].userTeams[j].availableTo)) {
                  // timeSlot15[i]['available'] = element.memberSchedules[0].userTeams[j].leaveType ? 'timeoff' : 'available';
                  const teamName = element.memberSchedules[0].userTeams[j]?.teamName ? `<b>${element.memberSchedules[0].userTeams[j]?.teamName}</b>` + ' - ' : '';
                  if (element.memberSchedules[0].userTeams[j].leaveType) {
                    timeSlot15[i]['available'] = 'timeoff';
                    const fullDayOffString = teamName + element.memberSchedules[0].userTeams[j]?.leaveType + ' (All Day)';
                    const timeOffString = teamName + element.memberSchedules[0].userTeams[j]?.leaveType + ' (' +
                    element.memberSchedules[0].userTeams[j].slotTimeStr + ')';
                    timeSlot15[i]['slotTimeStr'] = element.memberSchedules[0].userTeams[j]?.fullDayOff ? fullDayOffString : timeOffString;
                    element.leaveType = element.memberSchedules[0].userTeams[j].leaveType;
                    element.scheduleSource = element.memberSchedules[0].userTeams[j].scheduleSource;
                    element.fullDayOff = element.memberSchedules[0].userTeams[j].fullDayOff;
                    element.notes = element.memberSchedules[0].userTeams[j].notes;
                    element.activeShiftScheduleId = element.memberSchedules[0].userTeams[j]?.scheduleId;
                  } else {
                    timeSlot15[i]['available'] = 'available';
                    timeSlot15[i]['slotTimeStr'] = teamName + element.memberSchedules[0].userTeams[j].slotTimeStr;
                  }
                }
              }
            }
          }
          element.timeslots15m = JSON.parse(JSON.stringify(timeSlot15));
          this.providerFinalResponse.push(element);
        });
      },
        (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
          // this.isLoaded = true;
        });
  }

  addTimeOff(teamShiftDetail) {
    const addSlotDetails = {
      date: teamShiftDetail?.memberSchedules[0]?.dateStr,
      firstName: teamShiftDetail?.firstName,
      lastName: teamShiftDetail?.lastName,
      userId: teamShiftDetail?.id,
      providerId: teamShiftDetail?.providerId,
      teamId: teamShiftDetail?.memberSchedules[0]?.userTeams.length ?
        teamShiftDetail?.memberSchedules[0]?.userTeams[0].teamId : '',
    };
    this.showAddTimeOffPopup = true;
    this.addTimeOffDetails = addSlotDetails;
  }

  editSlot(teamShiftDetail) {
    const editSlotDetails = {
      date: teamShiftDetail?.memberSchedules[0]?.dateStr,
      firstName: teamShiftDetail?.firstName,
      lastName: teamShiftDetail?.lastName,
      team: teamShiftDetail?.memberSchedules[0]?.userTeams.length ?
        teamShiftDetail?.memberSchedules[0]?.userTeams[0].teamName : [],
      userId: teamShiftDetail?.id,
      providerId: teamShiftDetail?.providerId,
      userType: teamShiftDetail?.userType,
    };
    this.showEditPopup = true;
    this.editSlotDetails = editSlotDetails;
  }

  confirmCancelLeave(teamShiftDetail) {
    const weekMonthDate = new WeekMonthDatePipe();
    this.confirmationService.confirm({
      message: `Are you sure you want to cancel ${teamShiftDetail?.firstName} ${teamShiftDetail?.lastName}'s leave for ${weekMonthDate.transform(teamShiftDetail?.memberSchedules[0]?.dateStr)} ?`,
      header: this.commonService.getLabel('label_cancel_leave'),
      // icon: 'fa fa-question-circle',
      accept: () => {
        this.cancelLeave(teamShiftDetail?.activeShiftScheduleId);
      },
    });
  }

  cancelLeave(scheduleId) {
    this.manageOpenShiftsService.cancelMemberLeave(scheduleId).subscribe((res) => {
      this.uiService.showMessage(res.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.getTeamMemberList();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onClickOfPopupButton(isEditSlot: boolean) {
    this.showEditPopup = false;
    if (isEditSlot) {
      this.getTeamMemberList();
    }
  }

  closeAddTimeOffPopup(isAddedTimeOff: boolean) {
    this.showAddTimeOffPopup = false;
    if (isAddedTimeOff) {
      this.getTeamMemberList();
    }
  }

  sortTeamMembers() {
    this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
    this.offset = 0;
    this.getTeamMemberList();
  }

  addDeleteShift(userId: any, providerId: any, firstName: any, lastName: any, userType: any) {
    const addedMemberArr = this.teamMemberDetails.filter(ele => ele.userId === userId);
    if (addedMemberArr[0]?.memberSchedules[0]?.userTeams?.length) {
      const teamId = addedMemberArr[0]?.memberSchedules[0]?.userTeams[0]?.teamId;
      this.router.navigate(['/manage-shift/add-delete-shift-planning'], {
        queryParams: { userId: userId, providerId: providerId, f : firstName, l: lastName, userType: userType, teamId }
      });
    } else {
      this.router.navigate(['/manage-shift/add-delete-shift-planning'], {
        queryParams: { userId: userId, providerId: providerId, f : firstName, l: lastName, userType: userType }
      });
    }
  }

}
